/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Contact_Code_Type_CheckboxInputs */

const en_enum_contact_code_type_checkbox = /** @type {(inputs: Enum_Contact_Code_Type_CheckboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code Type Checkbox`)
};

const de_enum_contact_code_type_checkbox = /** @type {(inputs: Enum_Contact_Code_Type_CheckboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code Typ Checkbox`)
};

/**
* | output |
* | --- |
* | "Code Type Checkbox" |
*
* @param {Enum_Contact_Code_Type_CheckboxInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_contact_code_type_checkbox = /** @type {((inputs?: Enum_Contact_Code_Type_CheckboxInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Contact_Code_Type_CheckboxInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_contact_code_type_checkbox(inputs)
	return de_enum_contact_code_type_checkbox(inputs)
});